"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpanishIcon = SpanishIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SpanishIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    height: "600",
    viewBox: "0 0 900 600",
    width: "900"
  }, props), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#c60b1e",
    height: "600",
    width: "900"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#ffc400",
    height: "300",
    width: "900",
    y: "150"
  }));
}